// extracted by mini-css-extract-plugin
module.exports = {"prequals":"PrequalList_prequals__OGeqA"};